import { useQuery, useMutation } from '@maui/react-query'
import { useMatiApiClient } from './client'

export const useDuetAISummaryQuery = (payload, options = {}) => {
  const api = useMatiApiClient('duetai')

  return useQuery({
    ...options,
    queryFn: () => api.summary(payload),
    queryKey: ['duetaiSummary', payload.query, payload.modified_since],
    refetchOnWindowFocus: false
  })
}

export const useDuetAiSummaryFeedbackMutation = (options = {}) => {
  const api = useMatiApiClient('duetai')

  return useMutation({
    optimisticUpdateKey: ['duetAiSummaryFeedback'],
    mutationFn: (feedback) => {
      const response = api.summaryFeedback({ feedback })
      return response
    },
    ...options
  })
}
